import { FormField, Input, NonCancelableCustomEvent } from '@amzn/awsui-components-core';
import { BaseChangeDetail } from '@amzn/awsui-components-core/input/interfaces';
import React, { useContext } from 'react';
import { CodeRepoFormData } from './CodeRepoFormData';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { useValidation } from './ValidationHook';

interface InputFormFieldProps {
  fieldId: string;
  label: React.ReactNode;
  description?: React.ReactNode;
  placeholder?: string;
  value: string;
  setValue: (newValue: string) => CodeRepoFormData;
  validations?: Array<[(input: string) => boolean, string]>;
  stretch?: boolean;
}

export const InputFormField = (props: InputFormFieldProps) => {
  // @ts-expect-error TS2339 - strict migration
  const { setRepoData } = useContext(CodeRepoFormCtx);
  const handleChange = (event: NonCancelableCustomEvent<BaseChangeDetail>) => {
    const newValue = event.detail.value;
    const codeRepoUpdate = props.setValue(newValue);
    // @ts-expect-error TS7006 - strict migration
    setRepoData((prevState) => ({ ...prevState, ...codeRepoUpdate }));
  };
  // @ts-expect-error TS2345 - strict migration
  const validationError = useValidation(props.fieldId, props.value, props.validations);
  return (
    <FormField
      label={props.label}
      errorText={validationError}
      stretch={props.stretch}
      description={props.description}
      i18nStrings={{ errorIconAriaLabel: 'Error' }}
    >
      <Input
        value={props.value}
        placeholder={props.placeholder}
        onChange={handleChange}
        ariaRequired
      />
    </FormField>
  );
};
